"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isErrorRestResponse = isErrorRestResponse;
var _constants = require("../constants");
var _isRestResponse = require("./isRestResponse");
function isErrorRestResponse(response) {
  if (!(0, _isRestResponse.isRestResponse)(response)) {
    return false;
  }
  const {
    _response: {
      status
    }
  } = response;
  return status < _constants.MIN_SUCCESS_HTTP_CODE || status > _constants.MAX_SUCCESS_HTTP_CODE;
}
//# sourceMappingURL=isErrorRestResponse.js.map